var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-menu",
    { attrs: { "md-direction": "bottom-start", "md-align-trigger": "" } },
    [
      _c("md-button", { attrs: { "md-menu-trigger": "" } }, [
        _c("i", { staticClass: "material-icons" }, [_vm._v("menu")])
      ]),
      _vm._v(" "),
      _c(
        "md-menu-content",
        _vm._l(_vm.items, function(item) {
          return _c(
            "md-menu-item",
            { key: item.id, attrs: { href: item.url } },
            [_vm._v(_vm._s(item.label))]
          )
        }),
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a0bc4dc", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a0bc4dc","hasScoped":false,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/widgets/MobileMainMenuComponent.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-4a0bc4dc","hasScoped":false,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/widgets/MobileMainMenuComponent.vue
// module chunks = 1 2 3